
    function dsSetCookie(cname, cvalue, exhours) {
        var d = new Date();
        d.setTime(d.getTime() + (exhours * 60 * 60 * 1000 * 24));
        var expires = "expires=" + d.toGMTString();
        document.cookie = cname + "=" + cvalue + "; " + expires + "; path = /";
    }

    function dsGetCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[ i ];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    var popUp = dsGetCookie("ds");

    if (cvtemplating.showDiscountModal == false || popUp != "" || window.location.hostname == 'booking.clubvillamar.com' || window.location.hostname == 'cvrmdevbooking.clubvillamar.com') {
    } else {
        var show = function () {
            var route = Routing.generate('discount_signup_modal');
            $('#main-modal .modal-dialog').addClass('discount-signup');
            $('#main-modal .modal-content').load(route,function(e){$('#main-modal').modal('show');});
            var popUp = 1;
            dsSetCookie("ds", popUp, 365);
        }
        $(window).load(function () {
            var timer = window.setTimeout(show, 2000);
        });
    }
